import React from "react";
import { JumpStarter, SupportingTheCommunity, Streaks } from '../components/MedalsImageMapping';

type Medal = {
  key: string;
  title: string;
  unlocked: boolean;
  imageKey: string;
  earnedAt?: string | null;
  description?: string | null;
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  title: string;
  medals: Medal[];
  sectionKey: "jumpstarter" | "community" | "streak";
};

function getImageByKey(imageKey: string) {
  if (imageKey.startsWith("J")) return JumpStarter[imageKey];
  if (imageKey.startsWith("C")) return SupportingTheCommunity[imageKey];
  if (imageKey.startsWith("S")) return Streaks[imageKey];
  return "";
}

function getUpvoteSizeClass(imageKey: string) {
  if (imageKey === "J3") return "ym-upvote-xsmall";
  if (imageKey === "J4") return "ym-upvote-small";
  return "";
}

function getImage(sectionKey: string, code: string) {
  if (sectionKey === "jumpstarter") return JumpStarter[code];
  if (sectionKey === "community") return SupportingTheCommunity[code];
  if (sectionKey === "streak") return Streaks[code];
  return "";
}

const AchievementsModal: React.FC<Props> = ({ isOpen, onRequestClose, title, medals, sectionKey }) => {
  if (!isOpen) return null;

  return (
    <div className="ym-modal-overlay" role="dialog" aria-modal="true" aria-label={`${title} - All medals`}>
      <div className="ym-modal">
        <div className="ym-modal-header">
          <h2 className="ym-modal-title">{title}</h2>
          <button
            className="ym-modal-close"
            aria-label="Close"
            onClick={onRequestClose}
          >
            ×
          </button>
        </div>

        {sectionKey === "jumpstarter" && (
          <p className="ym-section-guide-m">
            Get active in the community by upvoting other people's favorites that you have tasted and also love.
          </p>
        )}

        <div className="ym-modal-body">
          <div className="ym-all-grid">
            {medals.map(m => (
              <div key={m.key} className="ym-medal-card ym-medal-card--all">
                <div className="ym-medal-wrap">
                  <img
                    src={m.unlocked ? getImageByKey(m.imageKey) : getImage(sectionKey, m.imageKey + "_locked")}
                    alt={m.title}
                    className={`ym-medal-img ${getUpvoteSizeClass(m.imageKey)}`}
                  />
                </div>
                <div className={`ym-medal-title ${m.unlocked ? "" : "is-locked"}`}>
                  {m.title}

                  {sectionKey === "jumpstarter" && m.imageKey === "J2" && m.description && (
                    <div className="ym-medal-subtext">
                      {m.description}
                    </div>
                  )}

                  {sectionKey === "jumpstarter" && m.imageKey === "J6" && (
                    <div className="ym-medal-subtext">
                      (Do at least 5 restaurant searches in a week)
                    </div>
                  )}

                  {sectionKey === "jumpstarter" && m.imageKey === "J7" && (
                    <div className="ym-medal-subtext">
                      (Use the Filter option 20 times from any category)
                    </div>
                  )}

                  {m.unlocked && m.earnedAt && (
                    <div className="ym-medal-date">
                      {new Date(m.earnedAt).toLocaleDateString()}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementsModal;
